/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/DailyChallenges/FreeCellChallenge',[
    'lodash',
    'absolute/stringmanager',
    'CardUI/IChallengeDefinition',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/CardLogic/Card',
    'SolitaireShared/FreeCellLogic/ChallengeAuthorities/CardToCardDailyFreeCellAuthority',
    'SolitaireShared/FreeCellLogic/ChallengeAuthorities/PlayCardDailyFreeCellAuthority',
    'SolitaireShared/FreeCellLogic/ChallengeAuthorities/PlayValuesDailyFreeCellAuthority',
    'SolitaireShared/FreeCellLogic/ChallengeAuthorities/SolveGameDailyFreeCellAuthority'
], function (_, _s, IChallengeDefinition, ChallengeConstants, Card, CardToCardDailyFreeCellAuthority, PlayCardDailyFreeCellAuthority, PlayValuesDailyFreeCellAuthority, SolveGameDailyFreeCellAuthority) {
    "use strict";


    var FreeCellChallenge = function (challengeType, parameters, config) {
        this.initFreeCellChallenge(challengeType, parameters, config);
    };


    FreeCellChallenge.constructor = FreeCellChallenge;
    FreeCellChallenge.prototype = Object.create(IChallengeDefinition.prototype);


    FreeCellChallenge.GoalType =
    {
        /// <summary>
        /// No parameters
        /// </summary>
        SolveGame: 0,

        /// <summary>
        /// PARAMETERS: NumberToPlay, ValueToPlay
        /// </summary>
        PlayValues: 1,

        /// <summary>
        /// PARAMETERS: StackCard, BaseCard
        /// </summary>
        CardToCard: 2,

        /// <summary>
        /// PARAMETERS: CardToPlay
        /// </summary>
        PlayCard: 3
    };

    FreeCellChallenge.prototype.GoalType = FreeCellChallenge.GoalType;


    FreeCellChallenge.prototype.initFreeCellChallenge = function (challengeType, parameters, config) {
        IChallengeDefinition.call(this, challengeType, parameters, config);
    };

    FreeCellChallenge.prototype.ConstructAuthority = function () {
        var authority = FreeCellChallenge.AuthorityTypes[this.ChallengeType](this.Parameters);
        this.SetupOptionsForAuthority(authority);

        return authority;
    };


    FreeCellChallenge.prototype.GetGoalDescription = function ()
    {
        try
        {
            switch (this.ChallengeType)
            {
                case FreeCellChallenge.GoalType.SolveGame:
                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_SolveDeck"),
                        [
                            (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                            this.AllowedMoves.toString()
                        ]
                    );
                case FreeCellChallenge.GoalType.PlayCard:
                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_PlayCardToFoundation"),
                        [
                            Card.GetSymbolStringFromShortName(this.Parameters[PlayCardDailyFreeCellAuthority.KeyCardToPlay]),
                            (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                            this.AllowedMoves.toString()
                        ]
                    );
                case FreeCellChallenge.GoalType.PlayValues:

                    var value = Card.GetLongValueName(this.Parameters[PlayValuesDailyFreeCellAuthority.Key_ValueToPlay]);
                    var numToPlay = parseInt(this.Parameters[PlayValuesDailyFreeCellAuthority.Key_NumToPlay]);

                    var valueKey = "Card_" + value;
                    if (!isNaN(numToPlay) && numToPlay > 1)
                    {
                        if (value.toUpperCase() == "SIX")
                            valueKey += "es";
                        else
                            valueKey += "s";
                    }
                    value = _s(valueKey);

                    return _s(this.CompleteGoalLocString("DailyChallengeGoal_PlayValuesToFoundation"),
                        [
                            numToPlay.toString(),
                            value,
                            (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                            this.AllowedMoves.toString()
                        ]
                    );
                default:
                    return "";
            }
        }
        catch (e) {
                return "";
        }
    };

    FreeCellChallenge.prototype.GetChallengeIconUrl = function () {
        return "Content/Icons/DailyChallenges/freecell.png";
    };

    FreeCellChallenge.prototype.GetModeName = function ()
    {
       return "FreeCell"; // TODO return SolitaireGamesMap.Titles[SolitaireGameMode.FreeCell];
    };

    FreeCellChallenge.prototype.GetShortGoalDescription = function ()
    {
        switch (this.ChallengeType)
        {
            case FreeCellChallenge.GoalType.SolveGame:
                if(this.AllowedMoves > 0)
                    return _s("Moves_Solve_Challenge");

                if(this.AllowedTime > 0)
                    return _s("Timed_Solve_Challenge");

                return _s("Solve_Challenge");

            case FreeCellChallenge.GoalType.PlayCard:
            case FreeCellChallenge.GoalType.PlayValues:
                if(this.AllowedMoves > 0)
                    return _s("Moves_Card_Challenge");

                if(this.AllowedTime > 0)
                    return _s("Timed_Card_Challenge");

                return _s("DCTile_Card_Challenge");

            default:
                return "";
        }
    };

    FreeCellChallenge.MakeSolveAuthority = function (param) { return new SolveGameDailyFreeCellAuthority(param); };
    FreeCellChallenge.MakePlayValuesAuthority = function (param) { return new PlayValuesDailyFreeCellAuthority(param); };
    FreeCellChallenge.MakeCardToCardAuthority = function (param) { return new CardToCardDailyFreeCellAuthority(param); };
    FreeCellChallenge.MakePlayCardAuthority = function (param) { return new PlayCardDailyFreeCellAuthority(param); };


    // note: the following relies on being indexed by Goal values above
    FreeCellChallenge.AuthorityTypes = [
        FreeCellChallenge.MakeSolveAuthority,
        FreeCellChallenge.MakePlayValuesAuthority,
        FreeCellChallenge.MakeCardToCardAuthority,
        FreeCellChallenge.MakePlayCardAuthority
    ];


    FreeCellChallenge.FromDictionary = function (spec)
    {
        var retval = null;
        var challengeType = parseInt(spec.Data["CHDEF_ChallengeType"]);
        var parameters = {};

        _.forEach(spec.Data, function (value, key) {
            if (key.indexOf("PARAM_") == 0) {
                var nkey = key.substring(6);
                parameters[nkey] = value;
            }
        });

        retval = new FreeCellChallenge(challengeType, parameters, spec);
        retval.FromDictionaryInternal(spec.Data);

        return retval;
    };

    FreeCellChallenge.FirstParameters = // TODO - should  be an array?
    {
        "SolveGame": null,
        "PlayValues": "NumberToPlay",
        "CardToCard": "StackCard",
        "PlayCard": "CardToPlay"
    };

    FreeCellChallenge.SecondParameters =
    {
        "SolveGame": null,
        "PlayValues": "ValueToPlay",
        "CardToCard": "BaseCard",
        "PlayCard": null
    };


    return FreeCellChallenge;

});
